module.exports = __webpack_public_path__ + "static/the-dutch-house-2f03c6a0c0052e0aa683a1192ded523a.jpg";